"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var class_transformer_1 = require("class-transformer");
var ImageAsset_1 = require("./ImageAsset");
var Episode_1 = require("./Episode");
var UrlIdMapper_1 = require("../../utils/UrlIdMapper");
// eslint-disable-next-line import/prefer-default-export
var Season = /** @class */ (function () {
    function Season() {
    }
    Season.createInstance = function (plainObject) {
        return class_transformer_1.plainToClass(Season, plainObject);
    };
    Season.createInstances = function (plainObjectArray) {
        return class_transformer_1.plainToClass(Season, plainObjectArray);
    };
    Object.defineProperty(Season.prototype, "id", {
        get: function () {
            return UrlIdMapper_1.urlToId(this.url);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Season.prototype, "brandId", {
        get: function () {
            return UrlIdMapper_1.urlToId(this.parentUrl);
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        class_transformer_1.Type(function () { return ImageAsset_1.ImageAsset; })
    ], Season.prototype, "images", void 0);
    __decorate([
        class_transformer_1.Type(function () { return Episode_1.Episode; })
    ], Season.prototype, "episodes", void 0);
    return Season;
}());
exports.Season = Season;
//# sourceMappingURL=Season.js.map